import { FormEvent, ReactElement, useState, useContext } from "react";
import { Button } from "@justworkshr/milo-core";
import { Form } from "@justworkshr/milo-form";

import { getEnvVariables } from "lib/environment";
import { GENERAL_ERROR } from "global-components/mfa/constants/pageAlertsCopy";

import PageAlertContext from "contexts/PageAlertContext";

import EmailInput from "../emailInput/EmailInput";
import FooterButtons from "global-components/footerButtons/FooterButtons";

import useRequestRecoverUsername from "pages/recoverUsername/hooks/useRequestRecoverUsername";

import styles from "./recover-username-form.module.css";

const RecoverUsernameForm = ({
  onComplete,
}: {
  onComplete: (email: string) => void;
}): ReactElement => {
  const [email, setEmail] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const onInputChange = (email: string, isEmailValid: boolean) => {
    setEmail(email);
    setIsFormValid(isEmailValid);
  };
  const {
    mutate: requestRecoverUsername,
    isLoading: isRequestingRecoverUsername,
  } = useRequestRecoverUsername();
  const { setAlert, removeAlert } = useContext(PageAlertContext);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    removeAlert();

    requestRecoverUsername(
      { email },
      {
        onSuccess: () => {
          onComplete(email);
        },
        onError: () =>
          setAlert({
            color: "destructive",
            message: GENERAL_ERROR,
          }),
      },
    );
  };

  return (
    <Form onSubmit={onSubmit}>
      <EmailInput
        email={email}
        onChange={onInputChange}
        message="Let us know the email address associated with your Justworks account, and we'll send you an email with your username."
        className={styles.emailInput}
      />

      <FooterButtons>
        <Button as="a" variant={"ghost"} href={getEnvVariables().oktaHostUrl}>
          Back to login
        </Button>
        <Button
          type="submit"
          variant="filled"
          loading={isRequestingRecoverUsername}
          disabled={!isFormValid}
        >
          Send email
        </Button>
      </FooterButtons>
    </Form>
  );
};

export default RecoverUsernameForm;
